module.exports = __webpack_public_path__ + "static/iso_4.d14d93a5.jpg";